// panel-wrapper.component.ts
import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";
import { NgxMatPopoverComponent } from "src/app/shared/components/tooltip/ngx-mat-popover/ngx-mat-popover.component";
import { SortChangedEvent, SurveyQuestion } from "src/app/shared/models/survey";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-wrapper-rating",
    templateUrl: "./rating-wrapper.component.html",
    styleUrls: ["./rating-wrapper.component.scss"],
    standalone: false
})
export class RatingWrapperComponent extends FieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef, static: true })
  // TS2612 fix.  Added declare.
  declare fieldComponent: ViewContainerRef;

  @ViewChild("popover", { static: true })
  readonly popover!: NgxMatPopoverComponent;

  openPopover(): void {
    this.popover.open();
  }

  public editQuestionClicked() {
    this.field.props.onEditQuestionClicked(
      this.field.props["question"]
    );
  }

  public deleteQuestionClicked() {
    this.field.props.onDeleteQuestionClicked(
      this.field.props["question"]
    );
  }

  public moveOrderUp() {
    const question = this.field.props["question"] as SurveyQuestion;
    const evt = {
      id: question.id,
      newSortId: question.sortId - 1,
    } as SortChangedEvent;
    this.field.props.onQuestionOrderChanged(evt);
  }
  public moveOrderDown() {
    const question = this.field.props["question"] as SurveyQuestion;
    const evt = {
      id: question.id,
      newSortId: question.sortId + 1,
    } as SortChangedEvent;
    this.field.props.onQuestionOrderChanged(evt);
  }
  public updateQuestionSortId(e){
    const question = this.field.props["question"] as SurveyQuestion;
    const evt = {
      id: question.id,
      newSortId: e.target.value,
      exact: true
    } as SortChangedEvent;
    this.field.props.onQuestionOrderChanged(evt);
  }
}
